import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

// Al completar, líneas con diferencia (contado ≠ sistema) generan un ajuste a la cantidad contada.
export const inventoryCountStatus = v.union(
  v.literal("draft"),
  v.literal("completed"),
  v.literal("cancelled"),
);

export const validatorInventoryCount = v.object({
  code: v.optional(v.string()),
  warehouseId: v.optional(v.id("warehouses")),
  branchId: v.optional(v.id("branches")), // derivada de la bodega
  status: inventoryCountStatus,
  countDate: v.number(),
  completedDate: v.optional(v.number()),
  notes: v.optional(v.string()),
  cancelReason: v.optional(v.string()),
  cancelDate: v.optional(v.number()),
  internalControl,
});

export const inventory_counts = defineTable(validatorInventoryCount)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_warehouse", ["warehouseId"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_state", ["internalControl.state"])
  .index("by_created_at", ["internalControl.createdAt"]);
